import { render, staticRenderFns } from "./BlockDeletedAgents.vue?vue&type=template&id=4cb7a341&scoped=true&"
import script from "./BlockDeletedAgents.vue?vue&type=script&lang=js&"
export * from "./BlockDeletedAgents.vue?vue&type=script&lang=js&"
import style0 from "./BlockDeletedAgents.vue?vue&type=style&index=0&id=4cb7a341&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb7a341",
  null
  
)

export default component.exports